import { applyTallCabinetHeight, getTallCabinetHeightDelta } from './tallCabinetHeightResizer';
import { applyTallCabinetWidthDepth } from './tallCabinetWidthDepthResizer';

export {
  applyTallCabinetHeight,
  applyTallCabinetWidthDepth,
  getTallCabinetHeightDelta,
};

export function applyTallCabinetGeometry(instance, shape) {
  if (!instance || !shape) {
    return;
  }

  applyTallCabinetHeight(instance, shape);
  applyTallCabinetWidthDepth(instance, shape);
}
